export interface Product {
  id: number;
  name: string;
  brand: string;
  category: string;
  image: string;
  alt: string;
  mrp: number;
  sellingPrice: number;
  description: string;
  weight: string;
  prepTime: string;
  dietary: string[];
  nutritional: {
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
  };
  inStock: boolean;
  featured: boolean;
}

export const products: Product[] = [
  // Divya Kamal Dips - Premium Regular Choco Dip (from price list)
  {
    id: 1,
    name: "Vanilla Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Vanilla Dip 750 gm.jpeg",
    alt: "Vanilla Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Rich and creamy vanilla dip perfect for fruits, bread sticks, and desserts",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 320, protein: 3, carbs: 55, fat: 12 },
    inStock: true,
    featured: true
  },
  {
    id: 2,
    name: "Vanilla Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Vanilla Dip 5 Kg.jpeg",
    alt: "Vanilla Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Rich and creamy vanilla dip perfect for fruits, bread sticks, and desserts - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 320, protein: 3, carbs: 55, fat: 12 },
    inStock: true,
    featured: false
  },
  {
    id: 3,
    name: "Strawberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Strawberry Dip 750 gm.jpeg",
    alt: "Strawberry Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Delicious strawberry dip with real fruit flavor, perfect for snacking",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 310, protein: 2, carbs: 58, fat: 10 },
    inStock: true,
    featured: true
  },
  {
    id: 4,
    name: "Strawberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Strawberry Dip 5 Kg.jpeg",
    alt: "Strawberry Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Delicious strawberry dip with real fruit flavor - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 310, protein: 2, carbs: 58, fat: 10 },
    inStock: true,
    featured: false
  },
  {
    id: 5,
    name: "Pista Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Pista Dip 750 gm.jpeg",
    alt: "Pista Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Premium pistachio dip with authentic nutty flavor",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 340, protein: 5, carbs: 52, fat: 14 },
    inStock: true,
    featured: true
  },
  {
    id: 6,
    name: "Regular Sweetheart Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Regular Sweetheart Dip 800 gm.jpeg",
    alt: "Regular Sweetheart Dip 750 gm",
    mrp: 351,
    sellingPrice: 280,
    description: "Sweet and delightful dip perfect for all occasions",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 325, protein: 3, carbs: 56, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 7,
    name: "Special Sweetheart Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Speacial Sweetheart Dip 750 gm.jpeg",
    alt: "Special Sweetheart Dip 1 Kg",
    mrp: 369,
    sellingPrice: 290,
    description: "Premium sweet dip with special blend of flavors",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 335, protein: 3, carbs: 58, fat: 12 },
    inStock: true,
    featured: false
  },
  {
    id: 8,
    name: "Special Sweetheart Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Special Sweetheart Dip 5 Kg.jpeg",
    alt: "Special Sweetheart Dip 5 Kg",
    mrp: 1558,
    sellingPrice: 1400,
    description: "Premium sweet dip with special blend of flavors - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 335, protein: 3, carbs: 58, fat: 12 },
    inStock: true,
    featured: false
  },
  {
    id: 9,
    name: "Mulberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Mulberry Dip 750 gm.jpeg",
    alt: "Mulberry Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Exotic mulberry flavored dip with rich taste",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 57, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 10,
    name: "Mulberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Mulberry Dip 5 Kg.jpeg",
    alt: "Mulberry Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Exotic mulberry flavored dip with rich taste - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 57, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 11,
    name: "Orange Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Orange Dip 750 gm.jpeg",
    alt: "Orange Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Tangy and sweet orange dip with citrus freshness",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 305, protein: 2, carbs: 56, fat: 10 },
    inStock: true,
    featured: true
  },
  {
    id: 12,
    name: "Orange Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Orange Dip 5 Kg.jpeg",
    alt: "Orange Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Tangy and sweet orange dip with citrus freshness - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 305, protein: 2, carbs: 56, fat: 10 },
    inStock: true,
    featured: false
  },
  {
    id: 13,
    name: "Pineapple Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Pineapple Dip 750 gm.jpeg",
    alt: "Pineapple Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Tropical pineapple dip with authentic fruit flavor",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 310, protein: 2, carbs: 57, fat: 10 },
    inStock: true,
    featured: false
  },
  {
    id: 14,
    name: "Mango Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Mango Dip 750 gm.jpeg",
    alt: "Mango Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Rich mango flavored dip, king of fruits in every bite",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 58, fat: 10 },
    inStock: true,
    featured: true
  },
  {
    id: 15,
    name: "Mango Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Mango Dip 5 Kg.jpeg",
    alt: "Mango Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Rich mango flavored dip - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 58, fat: 10 },
    inStock: true,
    featured: false
  },
  {
    id: 16,
    name: "Malai Kulfi Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Malai Kulfi Dip 750 gm.jpeg",
    alt: "Malai Kulfi Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Creamy malai kulfi flavored dip with traditional taste",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 330, protein: 4, carbs: 54, fat: 13 },
    inStock: true,
    featured: false
  },
  {
    id: 17,
    name: "Coconut Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Coconut Dip 750 gm.jpeg",
    alt: "Coconut Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Tropical coconut dip with rich and creamy texture",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 325, protein: 3, carbs: 53, fat: 13 },
    inStock: true,
    featured: false
  },
  {
    id: 18,
    name: "Coconut Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Coconut Dip 5 Kg.jpeg",
    alt: "Coconut Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Tropical coconut dip with rich and creamy texture - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 325, protein: 3, carbs: 53, fat: 13 },
    inStock: true,
    featured: false
  },
  {
    id: 19,
    name: "Butterscotch Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Butterscotch Dip 750 gm.jpeg",
    alt: "Butterscotch Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Classic butterscotch dip with caramel notes",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 320, protein: 3, carbs: 56, fat: 11 },
    inStock: true,
    featured: true
  },
  {
    id: 20,
    name: "Butterscotch Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Butterscotch Dip 5 Kg.jpeg",
    alt: "Butterscotch Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Classic butterscotch dip with caramel notes - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 320, protein: 3, carbs: 56, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 21,
    name: "Blueberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Blueberry Dip 750 gm.jpeg",
    alt: "Blueberry Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Premium blueberry dip with rich berry flavor",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 57, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 22,
    name: "Blueberry Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Blueberry Dip 5 Kg.jpeg",
    alt: "Blueberry Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Premium blueberry dip with rich berry flavor - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 57, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 23,
    name: "Blackcurrent Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Blackcurrent Dip 750 gm.jpeg",
    alt: "Blackcurrent Dip 750 gm",
    mrp: 400,
    sellingPrice: 295,
    description: "Exotic blackcurrant dip with tangy-sweet flavor",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 58, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 24,
    name: "Blackcurrent Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Blackcurrent Dip 5 Kg.jpeg",
    alt: "Blackcurrent Dip 5 Kg",
    mrp: 1880,
    sellingPrice: 1800,
    description: "Exotic blackcurrant dip with tangy-sweet flavor - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 315, protein: 2, carbs: 58, fat: 11 },
    inStock: true,
    featured: false
  },
  {
    id: 25,
    name: "Belgian Dark Choco Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Belgian Dark Choco Dip 750 gm.jpeg",
    alt: "Belgian Dark Choco Dip 750 gm",
    mrp: 423,
    sellingPrice: 300,
    description: "Premium Belgian dark chocolate dip for true chocolate lovers",
    weight: "750g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 340, protein: 4, carbs: 52, fat: 14 },
    inStock: true,
    featured: true
  },
  {
    id: 26,
    name: "Belgian Dark Choco Dip",
    brand: "Divya Kamal",
    category: "Dips & Spreads",
    image: "/products/dips/Belgian Dark Chocolate Dip 5 Kg.jpeg",
    alt: "Belgian Dark Choco Dip 5 Kg",
    mrp: 1980,
    sellingPrice: 1900,
    description: "Premium Belgian dark chocolate dip - Bulk Pack",
    weight: "5kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 340, protein: 4, carbs: 52, fat: 14 },
    inStock: true,
    featured: false
  },

  // Tajmahak Syrups - from price list (900 GM @ ₹95)
  {
    id: 27,
    name: "Strawberry Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Strawberry Syrup.jpeg",
    alt: "Strawberry Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Sweet strawberry syrup perfect for beverages and desserts",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 260, protein: 0, carbs: 65, fat: 0 },
    inStock: true,
    featured: true
  },
  {
    id: 28,
    name: "Rose Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Rose Syrup.jpeg",
    alt: "Rose Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Traditional rose syrup with authentic flavor",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 255, protein: 0, carbs: 64, fat: 0 },
    inStock: true,
    featured: false
  },
  {
    id: 29,
    name: "Pineapple Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Pineapple Syrup.jpeg",
    alt: "Pineapple Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Tropical pineapple syrup for refreshing drinks",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 258, protein: 0, carbs: 64, fat: 0 },
    inStock: true,
    featured: false
  },
  {
    id: 30,
    name: "Mango Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Mango Syrup.jpeg",
    alt: "Mango Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Rich mango syrup with authentic fruit flavor",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 262, protein: 0, carbs: 65, fat: 0 },
    inStock: true,
    featured: true
  },
  {
    id: 31,
    name: "Green Apple Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Green Apple Syrup.jpeg",
    alt: "Green Apple Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Tangy green apple syrup for mocktails and beverages",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 256, protein: 0, carbs: 64, fat: 0 },
    inStock: true,
    featured: false
  },
  {
    id: 32,
    name: "Butterscotch Syrup",
    brand: "Tajmahak",
    category: "Syrups",
    image: "/products/syrups/Butterscotch Syrup.jpeg",
    alt: "Butterscotch Syrup",
    mrp: 135,
    sellingPrice: 95,
    description: "Classic butterscotch syrup for ice creams and desserts",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 260, protein: 0, carbs: 65, fat: 0 },
    inStock: true,
    featured: false
  },

  // Divya Samrat Chatni - from price list
  {
    id: 33,
    name: "Watermelon Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Watermelon Chatni.jpeg",
    alt: "Watermelon Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Sweet and refreshing watermelon chatni",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 85, protein: 1, carbs: 21, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 34,
    name: "Strawberry Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Strawberry Chatni.jpeg",
    alt: "Strawberry Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Delicious strawberry chatni with natural fruit flavor",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 90, protein: 1, carbs: 22, fat: 0.3 },
    inStock: true,
    featured: true
  },
  {
    id: 35,
    name: "Saffron Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Saffron Chatni.jpeg",
    alt: "Saffron Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Premium saffron chatni with royal flavor",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 95, protein: 1, carbs: 23, fat: 0.4 },
    inStock: true,
    featured: true
  },
  {
    id: 36,
    name: "Red Gold Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Red Gold Chatni.jpeg",
    alt: "Red Gold Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Special blend chatni with rich flavor",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 88, protein: 1, carbs: 21, fat: 0.3 },
    inStock: true,
    featured: false
  },
  {
    id: 37,
    name: "Pineapple Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Pineapple Chatni.jpeg",
    alt: "Pineapple Chatni",
    mrp: 200,
    sellingPrice: 150,
    description: "Tropical pineapple chatni with tangy-sweet taste",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 87, protein: 1, carbs: 21, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 38,
    name: "Pineapple Budlee Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Pineapple Budlee Chatni.jpeg",
    alt: "Pineapple Budlee Chatni",
    mrp: 108,
    sellingPrice: 85,
    description: "Traditional pineapple budlee chatni in squeezy bottle",
    weight: "450g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 86, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 39,
    name: "Menthol Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Menthol Chatni.jpeg",
    alt: "Menthol Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Refreshing menthol chatni with cooling effect",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 82, protein: 1, carbs: 19, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 40,
    name: "Mitta Khajana Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Meetha Khajana Chatni.jpeg",
    alt: "Mitta Khajana Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Sweet treasure chatni with special blend",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 92, protein: 1, carbs: 22, fat: 0.3 },
    inStock: true,
    featured: false
  },
  {
    id: 41,
    name: "Mango Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Mango Chatni.jpeg",
    alt: "Mango Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Classic mango chatni with authentic flavor",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 89, protein: 1, carbs: 21, fat: 0.3 },
    inStock: true,
    featured: true
  },
  {
    id: 42,
    name: "Khus Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Khus Chatni.jpeg",
    alt: "Khus Chatni",
    mrp: 200,
    sellingPrice: 150,
    description: "Traditional khus flavored chatni",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 84, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 43,
    name: "Khus Budlee Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Khus Budlee Chatni.jpeg",
    alt: "Khus Budlee Chatni",
    mrp: 108,
    sellingPrice: 85,
    description: "Traditional khus budlee chatni in squeezy bottle",
    weight: "450g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 83, protein: 1, carbs: 19, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 44,
    name: "Sapna Kesariya Syrup Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Kesariya Syrup Chatni.jpeg",
    alt: "Sapna Kesariya Syrup Chatni",
    mrp: 150,
    sellingPrice: 110,
    description: "Kesariya flavored syrup chatni",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 91, protein: 1, carbs: 22, fat: 0.3 },
    inStock: true,
    featured: false
  },
  {
    id: 45,
    name: "Kesar Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Kesar Chatni.jpeg",
    alt: "Kesar Chatni",
    mrp: 165,
    sellingPrice: 135,
    description: "Premium kesar (saffron) chatni",
    weight: "900g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 94, protein: 1, carbs: 23, fat: 0.4 },
    inStock: true,
    featured: true
  },
  {
    id: 46,
    name: "Kesar Budlee Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Kesar Budlee Chatni.jpeg",
    alt: "Kesar Budlee Chatni",
    mrp: 108,
    sellingPrice: 85,
    description: "Traditional kesar budlee chatni in squeezy bottle",
    weight: "450g",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 93, protein: 1, carbs: 22, fat: 0.4 },
    inStock: true,
    featured: false
  },
  {
    id: 47,
    name: "Chandan Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Chandan Chatni.jpeg",
    alt: "Chandan Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Traditional chandan (sandalwood) flavored chatni",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 86, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 48,
    name: "Black Current Chatni",
    brand: "Divya Samrat",
    category: "Chatni",
    image: "/products/chatni/Black Current Chatni.jpeg",
    alt: "Black Current Chatni",
    mrp: 315,
    sellingPrice: 190,
    description: "Exotic blackcurrant chatni with rich flavor",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian", "Gluten-Free"],
    nutritional: { calories: 90, protein: 1, carbs: 22, fat: 0.3 },
    inStock: true,
    featured: false
  },

  // Yuhvi's Sweet Chatni (Decorative Topping) - from price list
  {
    id: 49,
    name: "Yuhvi's Ratrani Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Ratrani.jpeg",
    alt: "Yuhvi's Ratrani Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Ratrani flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 50,
    name: "Yuhvi's Rajani Ganddha Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Rajanigandha.jpeg",
    alt: "Yuhvi's Rajani Ganddha Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Rajani Ganddha flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: true
  },
  {
    id: 51,
    name: "Yuhvi's Panratna Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Panratna.jpeg",
    alt: "Yuhvi's Panratna Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Panratna flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 52,
    name: "Yuhvi's Orange Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Orange.jpeg",
    alt: "Yuhvi's Orange Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Orange flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 53,
    name: "Yuhvi's Mogra Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Mogra.jpeg",
    alt: "Yuhvi's Mogra Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Mogra flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: true
  },
  {
    id: 54,
    name: "Yuhvi's Kesar Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Kesar.jpeg",
    alt: "Yuhvi's Kesar Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Kesar flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  },
  {
    id: 55,
    name: "Yuhvi's Gulab Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Gulab.jpeg",
    alt: "Yuhvi's Gulab Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Gulab flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: true
  },
  {
    id: 56,
    name: "Yuhvi's Chandan Sweet Chatni",
    brand: "Yuhvi's",
    category: "Sweet Chatni",
    image: "/products/yuhvi/Yuhvi Chandan.jpeg",
    alt: "Yuhvi's Chandan Sweet Chatni",
    mrp: 459,
    sellingPrice: 280,
    description: "Chandan flavoured sweet chatni decorative topping",
    weight: "1kg",
    prepTime: "Ready to use",
    dietary: ["Vegetarian"],
    nutritional: { calories: 85, protein: 1, carbs: 20, fat: 0.2 },
    inStock: true,
    featured: false
  }
];
